import { render } from "./HomeView.vue?vue&type=template&id=4904a33d&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=4904a33d&scoped=true&lang=css"

import exportComponent from "/home/user/WebstormProjects/ynamly_vue-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4904a33d"]])

export default __exports__